import { render, staticRenderFns } from "./NCLDC2025.vue?vue&type=template&id=7ac8fe14&scoped=true"
import script from "./NCLDC2025.vue?vue&type=script&lang=js"
export * from "./NCLDC2025.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac8fe14",
  null
  
)

export default component.exports